<div class="container  no-padding min-height-100">
  <div class="d-flex justify-content-center mt-5 mb-5">
    <div class="row col-12 d-flex justify-content-center mt-4  no-padding">
      <div class="col-12   row   d-flex justify-content-center  align-items-center   no-padding"
        style="color: #000000;">


        <div class=" col-12 col-md-12 mb-3">
          <div class="row    d-flex justify-content-center">


            <div class="col-12 col-md-8 mt-1">
              <mat-form-field class="col-12" appearance="outline">
                <mat-label style="color:black">Buscar</mat-label>

                <!-- (keyup)="changeFilters()" -->
                <input (keyup)="activateButtonSearch()" [disabled]="loading" [(ngModel)]="textFilter" type="text"
                  matInput placeholder="buscar">
                <!-- *ngIf="textFilter.length==0" -->
                <button class="btn btn-sm btn-primary" *ngIf="!clickSearch" (click)="buttonSearchText()"
                  style="margin-top: -14px;" matSuffix>Buscar</button>
                <mat-icon (click)="clearTextFiler()" *ngIf="clickSearch" matSuffix>close</mat-icon>
              </mat-form-field>
            </div>

            <div class="col-6 col-md-2  mt-1">
              <mat-form-field appearance="outline" class="col-12">
                <mat-label>Elegir Fecha </mat-label>
                <input [disabled]="loading" [min]="today" (dateChange)="changeFilters()" [(ngModel)]="dateFilter"
                  matInput [matDatepicker]="picker" [disabled]="true">
                <mat-hint>MM/DD/YYYY</mat-hint>
                <mat-datepicker-toggle matSuffix [for]="picker">
                </mat-datepicker-toggle>
                <mat-datepicker #picker [disabled]="!false && loading"></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="col-6  col-md-2  mt-1">
              <mat-form-field class="col-12 " appearance="outline">
                <mat-label>Tipo Evento</mat-label>
                <mat-icon matSuffix>celebration</mat-icon>



                <mat-select [disabled]="loading" (selectionChange)="changeFilters()" [(ngModel)]="type">
                  <mat-option value="todos">Todos</mat-option>
                  <mat-option value="fiesta">Fiesta</mat-option>
                  <mat-option value="concierto">Concierto</mat-option>
                  <mat-option value="sunset">Sunset</mat-option>
                </mat-select>
              </mat-form-field>
            </div>



            <!-- 
                        <div class="col-5 col-md-2">

                            <button matTooltip="buscar hoy" style="margin-top: 10px;" (click)="searchToday()"
                                mat-raised-button class="col-12" color="primary">
                                <mat-icon style="  margin-right: 0px;">today</mat-icon> Hoy
                            </button>
                        </div> -->


          </div>
        </div>




      </div>

      <div class="col-12  row  d-flex justify-content-center no-padding">

        <!-- <p class=" d-flex justify-content-center text-center"> El resultado de la busqueda sera desde la fecha
                    indicada en
                    adelante con un total de 50 eventos</p> -->



        <div class="col-12 col-md-12 d-flex justify-content-center mb-2">
          <div class="col-8 col-md-3">
            <img src="../../../assets/texts/view-future-events.svg" style="width: 100%" alt="">
          </div>

        </div>

        <p class=" p-font-12 d-flex justify-content-center mt-1"> Fecha busqueda : {{date | date
                    :
                    'dd/MM/yyyy' }}</p>




        <app-spinner-loading *ngIf="loading"></app-spinner-loading>

        <app-div-no-result *ngIf="!events.length && !loading"></app-div-no-result>



        <div *ngFor="let event of events" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3   mt-2 mb-2  ">
          <app-card-event [event]="event">
          </app-card-event>
        </div>


      </div>

    </div>
  </div>
</div>
